import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

class InfoEC extends Component{
    
    render(){
        return (
            <div className="dap_info-socio">
                <h4>
                <FontAwesomeIcon icon={faInfoCircle} />
                ¡Lo sentimos!
                </h4>
                <p>
                Ha ocurrido un error inesperado.
                </p>
                <p>
                <Button
                    className="dap_btn-primary"
                    type="submit"
                    onClick={ e => { 
                        const {getAccounts} = this.props;
                        getAccounts();
                    } }
                >
                    Reintentar
                </Button>
                </p>
            </div>
        );
}
}
 
export default InfoEC;